import { useState } from "react";
import { auth } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword
} from "firebase/auth";

export default function AuthPage() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [login, setLogin] = useState(true);
  const [error, setError] = useState(null);

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  async function handle() {
    setError(null); // Reset any previous errors
    
    // Validate email format
    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }
    
    // Validate password
    if (pw.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    
    try {
      login
        ? await signInWithEmailAndPassword(auth, email, pw)
        : await createUserWithEmailAndPassword(auth, email, pw);
    } catch (err) {
      console.error("Auth error:", err);
      // Translating Firebase error codes to user-friendly messages
      if (err.code === 'auth/invalid-email') {
        setError("Please enter a valid email address");
      } else if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError("Invalid email or password");
      } else if (err.code === 'auth/email-already-in-use') {
        setError("This email is already registered");
      } else {
        setError("Authentication error: " + err.message);
      }
    }
  }

  return (
    <div style={{padding:40, maxWidth:400, margin:'0 auto'}}>
      <h2 style={{marginBottom:20, textAlign:'center'}}>
        {login ? "Login to MathBoss" : "Sign-up for MathBoss"}
      </h2>
      
      {error && (
        <div style={{color:'#e53e3e', marginBottom:15, padding:10, 
                    backgroundColor:'#FEE2E2', borderRadius:4}}>
          {error}
        </div>
      )}
      
      <div style={{marginBottom:15}}>
        <input 
          style={{width:'100%', padding:10, border:'1px solid #ccc', 
                 borderRadius:4, fontSize:16}}
          placeholder="Email"
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </div>
      
      <div style={{marginBottom:20}}>
        <input 
          style={{width:'100%', padding:10, border:'1px solid #ccc', 
                 borderRadius:4, fontSize:16}}
          placeholder="Password" 
          type="password"
          value={pw}
          onChange={e => setPw(e.target.value)}
        />
      </div>
      
      <button 
        style={{width:'100%', padding:10, backgroundColor:'#3B82F6', 
               color:'white', border:'none', borderRadius:4, 
               fontSize:16, cursor:'pointer'}}
        onClick={handle}>
        {login ? "Login" : "Create Account"}
      </button>
      
      <p style={{marginTop:15, textAlign:'center', cursor:"pointer", color:'#3B82F6'}} 
         onClick={() => setLogin(!login)}>
        {login ? "Need account? Sign-up" : "Have account? Login"}
      </p>
    </div>
  );
} 